import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { Link } from '../Link';
import { HELP_CENTER_LINK_SENT } from '../../constants/links';
import { QuestionLayoutBodyWrapper } from '../QuestionLayoutBodyWrapper';
import * as styles from './QuestionLayoutBodyMessageSent.css';
import { useDeviceType } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuestionLayoutBodyMessageSent = function QuestionLayoutBodyMessageSent(_ref) {
  var title = _ref.title,
    email = _ref.email,
    layoutType = _ref.layoutType;
  var deviceType = useDeviceType();
  return /*#__PURE__*/_jsx(QuestionLayoutBodyWrapper, {
    children: /*#__PURE__*/_jsxs("div", {
      className: cx(styles['container'], styles["container--".concat(layoutType)], styles["container--".concat(deviceType)]),
      children: [title && /*#__PURE__*/_jsx("div", {
        className: styles['header'],
        children: /*#__PURE__*/_jsx(ArticleHeading2, {
          as: "div",
          children: title
        })
      }), /*#__PURE__*/_jsx(ArticleParagraph1, {
        children: "\u041F\u0435\u0440\u0432\u044B\u0439 \u043E\u0441\u0432\u043E\u0431\u043E\u0434\u0438\u0432\u0448\u0438\u0439\u0441\u044F \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442 \u043E\u0442\u0432\u0435\u0442\u0438\u0442 \u043D\u0430 \u043F\u043E\u0447\u0442\u0443. \u041D\u0430 \u0432\u0441\u044F\u043A\u0438\u0439 \u0441\u043B\u0443\u0447\u0430\u0439 \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0439\u0442\u0435 \u043F\u0430\u043F\u043A\u0443 \xAB\u0421\u043F\u0430\u043C\xBB, \u0432 \u043D\u0435\u0451 \u0438\u043D\u043E\u0433\u0434\u0430 \u043F\u043E\u043F\u0430\u0434\u0430\u044E\u0442 \u043D\u0430\u0448\u0438 \u043F\u0438\u0441\u044C\u043C\u0430."
      }), /*#__PURE__*/_jsx("div", {
        className: styles['bottom'],
        children: /*#__PURE__*/_jsxs(ArticleParagraph1, {
          children: ["\u0415\u0441\u043B\u0438 \u0441\u0440\u043E\u0447\u043D\u043E \u043D\u0443\u0436\u0435\u043D \u043E\u0442\u0432\u0435\u0442, \u043F\u043E\u0438\u0449\u0438\u0442\u0435 \u0432", ' ', /*#__PURE__*/_jsx(Link, {
            href: HELP_CENTER_LINK_SENT,
            target: "_blank",
            size: "M",
            children: "\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u043E\u043C\xA0\u0446\u0435\u043D\u0442\u0440\u0435"
          }), ' ', "\u2014", /*#__PURE__*/_jsx("br", {}), " \u043E\u043D \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C."]
        })
      })]
    })
  });
};